import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'; // 👈 add this

import { routes } from './app.routes';
import { authTokenInterceptor } from './interceptors/auth-token.interceptor';
import { adminTokenInterceptor } from './interceptors/admin-token.interceptor';




export const appConfig: ApplicationConfig = {
  providers: [

    provideBrowserGlobalErrorListeners(),
    // provideZoneChangeDetection({ eventCoalescing: true }),
    provideZoneChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })
    ),
    provideHttpClient(withInterceptors([authTokenInterceptor, adminTokenInterceptor])),
    provideHotToastConfig({
      position: 'top-right',
      dismissible: true,
      duration: 3500,
      theme: 'toast',      // built-in theme; still works great with Tailwind/DaisyUI
      visibleToasts: 5,
      reverseOrder: false,
    }),

  ]
};

